// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__j8OBo","insightsList":"newBusinessInsightsMenu_insightsList__2Chs9","active":"newBusinessInsightsMenu_active__wpYBF"};